import { client, host } from "./client";
import { getLocalUserToken } from "./userAPI";

/** Mirrors the Rust `Agent` model. */
export interface ServerAgent {
  id: number;
  user_id: number;
  workspace_id: number;
  repo_id: number;
  name: string;
  status: string;
  session_id: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export function apiGetAgents(organizationId: number, workspaceId: number) {
  return client.get(`/organizations/${organizationId}/workspaces/${workspaceId}/agents`);
}

export function apiCreateAgent(
  organizationId: number,
  workspaceId: number,
  body: { name: string; repo_id: number }
) {
  return client.post(`/organizations/${organizationId}/workspaces/${workspaceId}/agents`, body);
}

export function apiDeleteAgent(organizationId: number, workspaceId: number, agentId: number) {
  return client.delete(`/organizations/${organizationId}/workspaces/${workspaceId}/agents/${agentId}`);
}

/**
 * URL of the Rocket websocket proxy for an agent. Auth travels as a `token`
 * query param because browsers can't set the Authorization header on a WS
 * handshake. The proxy ensures the sidecar is running and injects the repo path.
 */
export function agentWsUrl(organizationId: number, workspaceId: number, agentId: number): string {
  const wsBase = host.replace(/^http/, "ws"); // http->ws, https->wss
  const token = getLocalUserToken() ?? "";
  return (
    `${wsBase}/organizations/${organizationId}/workspaces/${workspaceId}` +
    `/agents/${agentId}/ws?token=${encodeURIComponent(token)}`
  );
}
